import { Component, Input, AfterViewInit, OnDestroy } from '@angular/core';

export interface CarouselSlide {
  imageUrl: string;
  title: string;
  description: string;
}

declare var bootstrap: any;

@Component({
  selector: 'app-carousel2',
  templateUrl: './carousel2.component.html',
  styleUrls: ['./carousel2.component.scss']
})
export class Carousel2Component implements AfterViewInit, OnDestroy {
  @Input() slides: CarouselSlide[] = [];

  private carouselInstance: any;

  ngAfterViewInit(): void {
    this.initCarousel();
  }

  ngOnChanges(): void {
    // re-init if slides change dynamically
    setTimeout(() => this.initCarousel());
  }

  private initCarousel(): void {
    if (!this.slides?.length) return;

    const element = document.getElementById('carousel2');

    if (element && (window as any).bootstrap) {
      this.carouselInstance = bootstrap.Carousel.getOrCreateInstance(element, {
        interval: 3000,
        pause: false,
        wrap: true
      });

      //this.carouselInstance.cycle();
    }
  }

  ngOnDestroy(): void {
    if (this.carouselInstance) {
      this.carouselInstance.dispose();
    }
  }

  trackByIndex(index: number): number {
    return index;
  }
}
